export const barrierTypeMappingHeaderData = [
    {
        field: 'RowId',
        headerName: 'Row ID',
        width: '80',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'RegionType',
        headerName: 'BP Region Type',
        width: '130',
        hideInTable: false,
        isDisabled: false,
        sortable: true
    },
    {
        field: 'WorkType',
        headerName: 'Work Type',
        width: '140',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'WorkTypeCode',
        headerName: 'Work Type Code',
        width: '140',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'CharacteristicDescription',
        headerName: 'Characteristic Description (SAP PM)',
        width: '185',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'CharacteristicValue',
        headerName: 'Characteristic Value (SAP PM)',
        width: '185',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'BarrierType',
        headerName: 'Barrier Type',
        width: '185',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'OrderIndex',
        headerName: 'Order Index',
        width: '110',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'DefaultBarrierType',
        headerName: 'Default Barrier Type',
        width: '155',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'Status',
        headerName: 'Status',
        width: '85',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedBy',
        headerName: 'Created By',
        width: '110',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedDate',
        headerName: 'Created Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'ModifiedBy',
        headerName: 'Modified By',
        width: '110',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'LastModifiedDate',
        headerName: 'Last Modified Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'Comments',
        headerName: 'Comments',
        width: '350',
        hideInTable: false,
        isDisabled: false,
    }
];

export const barrierTypeMappingInitialState = {
    RegionType: '',
    WorkTypeCode: '',
    WorkType: '',
    CharacteristicDescription: '',
    CharacteristicValue: '',
    BarrierType: '',
    OrderIndex: '',
    DefaultBarrierType: '',
    Status: 'Inactive',
    CreatedBy: '',
    CreatedDate: '',
    ModifiedBy: '',
    LastModifiedDate: '',
    Comments: ''
};

export const barrierTypeMappingSearchState = {
    RegionType: '',
    WorkTypeCode: '',
    WorkType: '',
    CharacteristicDescription: '',
    CharacteristicValue: '',
    BarrierType: '',
    OrderIndex: '',
    DefaultBarrierType: '',
    Status: '',
    CreatedBy: '',
    CreatedDate: '',
    ModifiedBy: '',
    LastModifiedDate: '',
    Comments: ''
};

export const barrierTypeMappingApiEndpoint = {
    read: 'ADMIN_GetBarrierTypeMappingDetails'
};
